// extracted by mini-css-extract-plugin
export var orderDetails = "_rh-2";
export var orderImage = "_rh-1";
export var orderMeta = "_rh-3";
export var orderSummary = "_rh-0";
export var rightArrow = "_rh-4";